import getHoursInRange from './getHoursInRange';
import getFullHour from './getFullHour';
import { takenSlot } from '@/logic/helpers/bookingSlots/helpToApplyTakenSlots';
import config from '@/config';

const hoursOfAssessment = (slot: takenSlot): string => {
  const bottomRangeDate: string = getBottomRangeDate(slot);
  const upperRangeDate: string = getUpperRangeDate(slot, bottomRangeDate);

  const hoursInRange: string[] = getHoursInRange(
    getFullHour(bottomRangeDate),
    getFullHour(upperRangeDate),
  );

  const firstProposedHour: string = hoursInRange[0];
  const lastProposedHour: string = hoursInRange[hoursInRange.length - 1];
  const assessmentEnd: string = getFullHour(slot.assessment_dates[0].date_end);
  const isProposedAssessment: boolean = firstProposedHour !== lastProposedHour;
  const shortTimezone = !config.isOnTestEnv ? localStorage.getItem('shortTimezone') : '';

  let finalHour: string;

  if (isProposedAssessment) {
    finalHour = `${firstProposedHour}-${lastProposedHour}`;
  } else {
    finalHour = `${firstProposedHour}-${assessmentEnd}`;
  }

  if (shortTimezone) finalHour = `${finalHour} (${shortTimezone})`;

  return finalHour;
};

const getBottomRangeDate = (slot: takenSlot): string => {
  let bottomRangeDate: string = slot.assessment_dates[0].date_start;

  slot.assessment_dates.forEach((date) => {
    if (date.status === 'confirmed') {
      bottomRangeDate = date.date_start;
      return;
    }
  });

  return bottomRangeDate;
};

const getUpperRangeDate = (slot: takenSlot, bottomRangeDate: string): string => {
  let upperRangeDate: string;

  slot.assessment_dates.every((date, idx, arr) => {
    const continueLoop = true;
    const nextFromTheEnd: number = idx + 1 <= arr.length ? idx + 1 : arr.length;

    const upperRangeDateIsValid: boolean =
      new Date(arr[arr.length - nextFromTheEnd]?.date_start).getTime() >
      new Date(bottomRangeDate).getTime();

    if (date.status === 'confirmed') {
      upperRangeDate = date.date_end;
      return !continueLoop;
    }

    if (upperRangeDateIsValid) {
      upperRangeDate = arr[arr.length - nextFromTheEnd]?.date_start;
      return !continueLoop;
    }
  });

  return upperRangeDate ?? slot.assessment_dates[0].date_end;
};

export default hoursOfAssessment;
